import { render, staticRenderFns } from "./PosProductoSearch.vue?vue&type=template&id=52d90f1c&scoped=true&"
import script from "./PosProductoSearch.vue?vue&type=script&lang=js&"
export * from "./PosProductoSearch.vue?vue&type=script&lang=js&"
import style0 from "./PosProductoSearch.vue?vue&type=style&index=0&id=52d90f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d90f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VPagination,VProgressCircular,VSkeletonLoader})
